import { render, staticRenderFns } from "./ClassicalAdd.vue?vue&type=template&id=4ac31a6c&scoped=true"
import script from "./ClassicalAdd.vue?vue&type=script&lang=js"
export * from "./ClassicalAdd.vue?vue&type=script&lang=js"
import style0 from "./ClassicalAdd.vue?vue&type=style&index=0&id=4ac31a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac31a6c",
  null
  
)

export default component.exports